import { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import Tips from "../../../Components/Tips/Tips";

const defaultCards = [
  {
    id: 1,
    title: "Faluda & Jilapi",
    image: '/Assets/Img/Recipe/imgHub_1_1.png',
    type: "image",
  },
  {
    id: 2,
    title: "Chicken Biryani",
    image: '/Assets/Img/Recipe/imgHub_1_2.png',
    type: "image",
  },
  {
    id: 3,
    title: "Mutton Biryani",
    image: '/Assets/Img/Recipe/imgHub_1_3.png',
    type: "image",
  },
  {
    id: 4,
    title: "Beef Biryani",
    image: '/Assets/Img/Recipe/imgHub_1_4.png',
    type: "video",
    videoUrl: "https://www.youtube.com/watch?v=cAgsmgXWZr4"
  },
  {
    id: 5,
    title: "Hot & Sour Soup",
    image: '/Assets/Img/Recipe/imgHub_3_1.png',
    type: "image",
  },
  {
    id: 6,
    title: "Lobster Bisque",
    image: '/Assets/Img/Recipe/imgHub_2_2.png',
    type: "video",
    videoUrl: "https://www.youtube.com/watch?v=jjuMJj2g7aw"
  },
  {
    id: 7,
    title: "Salad & Dessert",
    image: '/Assets/Img/Recipe/imgHub_2_3.png',
    type: "image",
  },
  {
    id: 8,
    title: "Fryed Rice & Noodles",
    image: '/Assets/Img/Recipe/imgHub_2_4.png',
    type: "image",
  }
];

const getYoutubeThumbnail = (url) => {
  const match = url.match(
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|embed|shorts|watch)\??v?=?)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : "";
};

export default function SellerTipsComponent({ data, isPending }) {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    const mappedCards =
      defaultCards?.map((item, index) => {
        const isVideo = item.type === "video";
        const imageUrl = isVideo
          ? getYoutubeThumbnail(item.videoUrl)
          : item.image;

        return {
          id: index + 1,
          title: item.title || "Untitled",
          image: imageUrl || "",
          hasPlayButton: isVideo,
        };
      }) || [];

    setCards(mappedCards);
  }, []);

  if (data?.showcases?.length === 0 && !isPending) return null;

  return (
    <div className="home-content-shell" style={{ paddingTop: 16, marginBottom: 24 }}>
      <Tips title={"Showcase"} cards={cards} isPending={isPending} />
    </div>
  );
}
